module.exports = __webpack_public_path__ + "static/media/freemason hall.a3252995.jpg";